import script from "./RemoveSecondaryIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./RemoveSecondaryIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__